import { Component, OnInit, AfterViewInit, NgZone, ViewChild, ViewContainerRef } from '@angular/core';
import { LegacyContentService } from 'src/app/services/legacy-content.service';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { BecareService } from 'src/app/services/becare.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { TypeManagerService } from 'src/app/services/type-manager.service';
import { ItemComponent } from 'src/app/interfaces/item-container';
import { CNItem } from 'src/app/models/cnitem';

declare var Ext: any;
declare var gContentPanel: any;
declare var gLegacyContentService: any;
declare var angular: any;
declare let Zone: any;

@Component({
  selector: 'app-legacy-content',
  templateUrl: './legacy-content.component.html',
  styleUrls: ['./legacy-content.component.scss']
})
/**
 * Implement all Ext.JS related functions
 */
export class LegacyContentComponent implements OnInit, AfterViewInit {

  public content: SafeHtml;
  public contentPanel: any;
  public extViewport: any;
  public isLegacy = true;
  public component;

  @ViewChild('itemContainer', {read: ViewContainerRef}) itemContainerRef: ViewContainerRef;

  private currentContentUrl = '';
  private currentContentParams = '';

  private componentRef;

  constructor(private legacycontent: LegacyContentService, private sanitizer: DomSanitizer,
              public becare: BecareService, private http: HttpClient, private cookie: CookieService,
              private typeManager: TypeManagerService, private ngZone: NgZone) {
  }

  ngOnInit(): void {
    this.legacycontent.contentPanel = this;
    this.legacycontent.setContent.subscribe(content => {
      this.isLegacy = true;
      this.content = this.sanitizer.bypassSecurityTrustHtml(content);
    });
    this.legacycontent.setContentUrl.subscribe(url => {
      this.isLegacy = true;
      if (this.currentContentUrl !== url) {
        this.loadContentUrl(url);
        this.currentContentUrl = url;
      }
    });
    this.legacycontent.setContentParams.subscribe(params => {
      this.isLegacy = true;
      const stringParams = JSON.stringify(params);
      if (this.currentContentParams !== stringParams) {
        this.loadContentUrl(params.url, params.postparams);
        this.currentContentParams = stringParams;
      }
    });
    this.legacycontent.setComponent.subscribe(component => {
      this.isLegacy = false;
      const componentName = (component as [string, CNItem])[0];
      const data = (component as [string, CNItem])[1];
      if (this.componentRef) {
        this.componentRef.destroy();
        this.componentRef = undefined;
        this.itemContainerRef.clear();
      }
      if (this.typeManager.typeMap(componentName) && this.itemContainerRef) {
        const componentFactory = this.typeManager.typeMap(componentName);
//        this.itemContainerRef.clear();
        this.componentRef = this.itemContainerRef.createComponent<ItemComponent>(componentFactory);
        if (data) {
          this.componentRef.instance.item = data;
        }
      }
    });
    gLegacyContentService = this.legacycontent;
  }

  ngAfterViewInit(): void {

    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        console.log('contentel : ', document.getElementById('contentel'));
        this.contentPanel = new Ext.Panel(
        {
          region: 'center',
          el: 'content',
          contentEl: 'contentel',
          autoScroll: true,
          margins: '0 0 0 0',
          tbar: []
        });
        gContentPanel = this.contentPanel;
        Ext.onReady(() => {
          Ext.QuickTips.init();
          this.extViewport = new Ext.Viewport({
            layout: 'border',
            items: [{
              region: 'north',
              contentEl: 'headerfake',
              height: 122,
              layout: 'fit',
              margins: '0 0 0 0',
            },
            {
              region: 'west',
              contentEl: 'leftmenufake',
              width: 60,
              layout: 'fit',
              margins: '0 0 0 0',
            },
            this.contentPanel]
          });
        });
      });
    });
  }

  loadContentUrl(url: string, postparams?: any) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const bearer = 'Bearer ' + this.becare.bearer;
        if (postparams) {
          let body = new HttpParams();
          const paramskeys = Object.keys(postparams);
          paramskeys.forEach(paramkey => {
            const paramvalue = postparams[paramkey];
            body = body.set(paramkey, paramvalue);
          });
          this.http.post(url, body,
                        {
                          headers: {Authorization: bearer,
                          'Content-Type': 'application/x-www-form-urlencoded'
                        }, withCredentials: true, responseType: 'text'})
          .subscribe(results => {
            try {
              this.contentPanel.el.update(results, true, (args) => {
                // Get AngularJS controller for this content
                const controllers = angular.element(this.contentPanel.el.dom).find('div[ng-controller]');
                if (controllers.length > 0) {
                  this.activateAngularJSView();
                }
              });
            } catch (exception) {
              this.content = 'Exception : ' + exception.message + ' during call to ' + url;
            }
          }, error => {
            this.content = 'Error : ' + error;
          });
        } else {
          this.http.get(url, {headers: {Authorization: bearer}, withCredentials: true, responseType: 'text'}).subscribe(results => {
            try {
              this.contentPanel.el.update(results, true);
            } catch (exception) {
              this.content = 'Exception : ' + exception.message + ' during call to ' + url;
            }
          }, error => {
            this.content = 'Error : ' + error;
          });
        }
      });
    });
  }

  activateAngularJSView() {
    const controllerEl = angular.element(this.contentPanel.el.dom);
    const mController = angular.element(document.getElementById('appjs'));
    if (mController && typeof(mController.scope) !== 'undefined') {
      mController.scope().activateView(controllerEl);
    }
  }
}
